import React from "react"

export default function ShareBoxInterfaceEssentialIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
			<g clipPath="url(#clip0_359_17258)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M15.8047 7.52443C16.0651 7.78478 16.0651 8.20689 15.8047 8.46724L11.8047 12.4672L10.8619 11.5244L13.7239 8.6625L5.33333 8.6625L5.33333 7.32917L13.7239 7.32917L10.8619 4.46724L11.8047 3.52443L15.8047 7.52443ZM8.66667 1.0625C9.03486 1.0625 9.33333 1.36098 9.33333 1.72917L9.33333 4.39583L8 4.39583L8 2.39583L1.33333 2.39583L1.33333 13.5958L8 13.5958L8 11.5958L9.33333 11.5958L9.33333 14.2625C9.33333 14.6307 9.03486 14.9292 8.66667 14.9292L0.666664 14.9292C0.298475 14.9292 -2.50043e-06 14.6307 -2.48434e-06 14.2625L-1.93649e-06 1.72917C-1.9204e-06 1.36098 0.298475 1.0625 0.666665 1.0625L8.66667 1.0625Z"
					fill="black"
				/>
			</g>
			<defs>
				<clipPath id="clip0_359_17258">
					<rect width="16" height="16" fill="white" />
				</clipPath>
			</defs>
		</svg>
	)
}
